import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'reactstrap';
import entityComposition from '../common/classes/entityComposition';
import { labelSelector, styleSelector } from './selectors';
import widthSelector from './selectors/widthSelector';

// column wraps one child
const Column = ({
  children: _children = null,
  style: _style = null,
  width: _width = {
    size: 12
  },
  className: _className = ''
}) => {
  const classes = `align-self-end ${_className} Column`;
  return /*#__PURE__*/React.createElement(Col, {
    className: classes,
    md: _width,
    style: _style
  }, _children);
};
Column.propTypes = {
  children: PropTypes.node,
  content: PropTypes.shape({}),
  // eslint-disable-next-line react/no-unused-prop-types
  minControlWidth: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  width: PropTypes.shape({})
};
export { Column as TestGridCol, widthSelector as testWidthSelector };
export default entityComposition(Column, [], {
  label: labelSelector,
  width: widthSelector,
  style: styleSelector
});